import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Guard
import { AuthGuard } from '../auth/services/auth-guard.service';
import { AnonymousGuard } from '../auth/services/anonymous-guard.service';

const routes: Routes = [
  {
    path: '',
    canActivate: [AnonymousGuard],
    loadChildren: 'app/auth/auth.module#AuthModule'
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadChildren: 'app/participant/participant.module#ParticipantModule'
  },
  {
    path: 'project',
    canActivate: [AuthGuard],
    loadChildren: 'app/project/project.module#ProjectModule'
  },
  {
    path: 'invite',
    loadChildren: 'app/invite/invite.module#InviteModule'
  },
  {
    path: 'help-support',
    loadChildren: 'app/help-support/help-support.module#HelpSupportModule'
  }
];

export const Routing: ModuleWithProviders = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// ./src/app/routing/app.routing.ts